export default __webpack_public_path__ + "static/media/InternalGreen.d4e91af0.png";